import axios from 'axios';
import apiConfig from '../config/apiConfig';

/** Current locale code for API (set by app when locale changes). Used for X-Locale header. */
let apiLocaleCode = '';

export function setApiLocale(code) {
  apiLocaleCode = code || '';
}

export const createAxiosInstance = (token, websiteSlug = apiConfig.WEBSITE_SLUG) => {
  const instance = axios.create({
    baseURL: apiConfig.BASE_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  instance.defaults.headers.common['X-Website-Slug'] = websiteSlug;

  instance.interceptors.request.use((config) => {
    if (apiLocaleCode) config.headers['X-Locale'] = apiLocaleCode;
    return config;
  });

  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return instance;
};

